import {SecureService} from "@/services/superclasses/secure-service";
import {CorporateClient} from "@/interfaces/corporate-client";

const api = window.contextPath + '/rest/corporate-clients';

export class CorporateClientSecureService extends SecureService {

    public loadByPerson = async (): Promise<CorporateClient> => {
        return this.data(await this.get<CorporateClient>(`${api}/by-person`))
    };
}

export const corporateClientSecureService = new CorporateClientSecureService()